import type { FunctionComponent } from "react"

import NextImage from "next/image"

import { Text } from "@jobteaser/spark/components/Text"

import { getOptimizedImageSrc } from "@/modules/kontent/helpers/getOptimizedImageSrc"

import styles from "./Image.module.css"

type ImageProps = {
  alt_description?: string
  credit?: string
  title?: string
  url: string
}

export const Image: FunctionComponent<ImageProps> = ({ alt_description: altDescription, credit, title, url }) => {
  const caption = credit || title
  const alt = altDescription || title || ""
  const shouldShowAltDescription = caption !== alt

  return (
    <figure className={styles.main}>
      <NextImage
        alt={shouldShowAltDescription ? alt : ""}
        height={768}
        src={getOptimizedImageSrc({
          dpr: 1,
          fit: "clip",
          src: url,
        })}
        width={768}
      />

      {!!caption && (
        <Text as="figcaption" variant="caption1Underline">
          {caption}
        </Text>
      )}
    </figure>
  )
}
